import type { ReactNode } from 'react';

import styles from './TooltipRows.module.scss';

export interface TooltipRow {
    key: string;
    value: string;
}

export interface TooltipRowsProps {
    /** Label and value pairs; a row with an empty key shows the value alone. */
    rows?: TooltipRow[];
    /** `two-column` lays the pairs out in two columns, for a long list. */
    layout?: 'one-column' | 'two-column';
    /** Free content below the rows. */
    children?: ReactNode;
}

/** Tooltip content laid out as label: value rows, passed to a Tooltip's `content`. */
export function TooltipRows(props: TooltipRowsProps) {
    const { rows, layout = 'one-column', children } = props;

    return (
        <div className={styles.tooltipRows}>
            <div data-type="tooltip-content" data-layout={layout}>
                {rows?.map((row) => (
                    <div key={row.key}>
                        <div>
                            {row.key}
                            {row.key ? ':' : ''}
                        </div>
                        <div>{row.value}</div>
                    </div>
                ))}
            </div>
            {children}
        </div>
    );
}

export default TooltipRows;
